import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptSeineSaintDenis93 = () => {
  return (
    <DepartmentTemplate
      department="Seine-Saint-Denis"
      departmentNumber="93"
      cities="Saint-Denis, Montreuil, Aubervilliers, Aulnay-sous-Bois"
      region="Île-de-France"
    />
  );
};

export default DeptSeineSaintDenis93;
